export default {
  'app.i18n.demo': '多語言示例',
  'app.i18n.content': '本區塊用來展示多語言切換能力',
};
